import React, {useEffect, useState } from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import { Container } from '@material-ui/core'
import { Images } from '../../../helpers';
import { Link } from 'react-router-dom'
import MUIDataTable from "mui-datatables";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SettingsIcon from '@material-ui/icons/Settings';
import AddKeywordModal from '../../../components/Createdimage/AddKeywordModal';
const BreadcrumbData = [
  {
    id: 1,
    page_title: "Dashboard",
    page_path: "/",
    icon: "tachometer",
  },
  {
    id: 2,
    page_title: "Categories",
    page_path: "/",
    icon: "tachometer",
  }
]
const CreatedImageList = () => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [crt_created_image_id, setCurrentId] = useState(null);
  const [isOpenKeyword, setOpenKeyword] = useState(false);
  const getCreatedImage = async () => {
    let resp = await Images.getCreatedImage();
    if (resp && resp.status) {
        setData(resp.createdImage)
        setLoading(false)
        
      console.log(resp);
    }
  }
  useEffect(() => {
    getCreatedImage();
  }, [])
const closeModal = () =>{
  setOpenKeyword(false)
}

  const deleteImage = async (id) =>{
    let resp = await Images.deleteCreatedImage(id);
    if(resp){
      let newData = data.filter(el=>el.id !== id);
      setData(newData);
    }
  }

  const imageKeywords = (id) =>{
    setCurrentId(id);
    let fData = data.find(el=>el.id === id);
    setKeywords(fData.keywords);
    setOpenKeyword(true)
  }
  const addNewKeyword = async (value)=>{
     let resp = await Images.addKeywordCreatedImage(value);
     if(resp){
      if(resp.status){
        setKeywords(resp.newData)
      }
     
     }
  }
  const deleteKeyword = async (id)=>{
       let resp = await Images.deleteKeywordCreatedImage(id);
       if(resp){
        if(resp.status){
          const newData = keywords.filter(el=>el.id !== id);
          setKeywords(newData)

       }
      }
  }
  const columns = [{
    name: "#SL",
    label: "#SL",
    options: {
      filter: false,
      sort: false
    }
  }, {
    name: "Title",
    label: "Title",
    options: {
      filter: false,
      sort: false
    }
  }, {
    name: "Size",
    label: "Size",
    options: {
      filter: false,
      sort: false
    }
  }, "Category", {
    name: "Image",
    label: "Image",
    options: {
      filter: false,
      sort: false
    }
  }
    ,
  {
    name: "Actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false
    }
  },

  ]
  return (
    <>
      <Breadcumb items={BreadcrumbData} />
      <div className="page-wrapper pd30">
        <Container >
      

              <div className='page-inner-header'>
                <h3 className='m-0'>Created Images</h3>
                <Link to={`/app/images/gallery`} className="btn-primary action-btn">
                  Create New
                </Link>
              </div>
              {
                isLoading ? "Data Loading..." : <MUIDataTable
                  title="Categories"
                  data={data.map((item, i) => {

                    return [
                      ++i,
                      item.image_name,
                      item.image_size,
                      item.category?.name,
                      <div style={{width:'100px'}}> 
                        {
                          item.created_image !== null && <img src={item.created_image} alt="" style={{width:'100%'}}/>
                        }
                      </div>,
                      <div className='actions'>
                       
                        <a href={`/app/images/create/${item.id}`} className=" btn-info action-btn">
                          <EditIcon fontSize="small" />
                        </a>
                        <button className=" btn-warning action-btn" onClick={()=>imageKeywords(item.id)}>
                        <SettingsIcon fontSize="small" />
                         </button>
                        <button onClick={()=>deleteImage(item.id)} className=" btn-danger action-btn">
                          <DeleteIcon fontSize="small" />
                        </button>
                      </div>
                    ]
                  })}
                  columns={columns}
                />
              }
            
          
        </Container>
      </div>
      <AddKeywordModal isOpen={isOpenKeyword} closeModal={closeModal} keywords={keywords} crt_created_image_id={crt_created_image_id} addNewKeyword={addNewKeyword} deleteKeyword={deleteKeyword}/>
    </>
  )
}

export default CreatedImageList